import axios from '@fs/zion-axios'
import { getUser } from '@fs/zion-user'
import useStateManager from './useStateManager'
import useFetchData from './useFetchData'

const fetchShowTempleInfo = async (isMember) => {
  // do not bother fetching if not a member--just return falsy value
  if (!isMember) {
    return false
  }
  const { data } = await axios.get('/service/tree/tree-data/profile/pref/showLDSTempleInfo')
  const dataJson = data?.data
  return dataJson && JSON.parse(dataJson)?.pref
}

const updateShowTempleInfo = async (pref) => {
  await axios.post('/service/tree/tree-data/profile/pref/showLDSTempleInfo', { pref })
  await persistShowTempleInfo(pref)
}

export default function useShowTempleInfo(isMember) {
  const { data: remoteShowTempleInfo, loading: showTempleInfoLoading } = useFetchData(fetchShowTempleInfo, {
    initialData: false,
    requestFnArg: isMember,
  })
  const { state: localShowTempleInfo, handleChangeState: handleChangeShowTempleInfo } =
    useStateManager(updateShowTempleInfo)
  const showTempleInfo = localShowTempleInfo ?? remoteShowTempleInfo

  return {
    showTempleInfo,
    showTempleInfoLoading,
    handleChangeShowTempleInfo,
  }
}

// Persist to sessionStorage with the proper key so that other pages can use it.
async function persistShowTempleInfo(pref) {
  const { cisId } = await getUser()
  const key = `FS.fs-templeinfo-${hashCode(cisId)}`
  sessionStorage.setItem(key, JSON.stringify({ pref }))
}

// copied from https://github.com/fs-webdev/hf/blob/master/assets/js/fs/storage.js#L80
function hashCode(str) {
  let ret = 0
  for (let i = 0, len = str.length; i < len; i++) {
    // eslint-disable-next-line no-bitwise
    ret = (31 * ret + str.charCodeAt(i)) << 0
  }
  return ret
}
